import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './paypal_page.less'
import PayPalNavigation from 'components/common/paypal_navigation'
import PayPalFooter from 'components/common/paypal_footer'

class PayPalPage extends React.Component {
  static propTypes = {
    showHeader: PropTypes.bool,
    showFooter: PropTypes.bool,
    children: PropTypes.any,
  }

  static defaultProps = {
    showHeader: true,
    showFooter: true,
  }

  render() {
    let contentStyles = ['content-inside']
    if (!this.props.showHeader) {
      contentStyles.push('no-header')
    }
    if (!this.props.showFooter) {
      contentStyles.push('no-footer')
    }

    return (
      <div>
        {this.props.showHeader && (
          <input
            type="checkbox"
            id="toggleNavigation"
            className="vx_globalNav-toggleCheckbox"
          />
        )}
        {this.props.showHeader && (
          <PayPalNavigation element="desktopHeaderHtml" />
        )}
        <div className="vx_foreground-container foreground-container">
          {this.props.showHeader && (
            <PayPalNavigation element="mobileHeaderHtml" />
          )}
          <section
            styleName={contentStyles.join(' ')}
            className="vx_mainContent contents"
            id="contents"
            role="main"
          >
            {this.props.children}
            <div styleName="clear" />
          </section>
          {this.props.showFooter && <PayPalFooter />}
        </div>
      </div>
    )
  }
}

export default cssModules(PayPalPage, styles, { allowMultiple: true })
